export default {
  // Header Navigation
  'nav.features': 'Özellikler',
  'nav.applications': 'Uygulama Alanları',
  'nav.service': 'Servis',
  'nav.fairs': 'Fuarlar',
  'nav.layoutPlan': 'Yerleşim Planı',
  'nav.cuttingThickness': 'Kesim Kalınlıkları',
  'nav.getQuote': 'Teklif İste',
  'nav.eCatalog': 'E-Katalog',
  'nav.onlineOrder': 'Online Sipariş',
  
  // Hero Section
  'hero.title': 'Fiber Lazer Kesimde Güvenilir Çözüm Ortağınız',
  'hero.subtitle': 'AJAN LAZER, fiber lazer kesim makinelerinde güvenilir ve yenilikçi üretici. Yerli üretim gücü ile sanayiye değer katıyoruz.',
  'hero.closedCabin': 'Kapalı Kabin Fiber Lazer',
  'hero.mobileCabin': 'Gezer Kabin Fiber Lazer',
  'hero.layoutPlan': 'Yerleşim Planı',
  'hero.cuttingThickness': 'Kesim Kalınlıkları',
  
  // Specifications
  'specs.title': 'Genel Özellikler',
  'specs.closedCabin': 'Kapalı Kabin Genel Özellikleri',
  'specs.mobileCabin': 'Gezer Kabin Genel Özellikler',
  'specs.laserPower': 'Lazer Gücü',
  'specs.zAxisHeight': 'Z-Eksen Hareket Yüksekliği',
  'specs.xyPositionAccuracy': 'X/Y Eksenleri Pozisyon Hassasiyeti',
  'specs.xyRepeatAccuracy': 'X/Y Eksenleri Tekrarlama Hassasiyeti',
  'specs.xyMaxSpeed': 'X/Y Maksimum Hızı',
  'specs.xyMaxSpeedValue': '88 metre/dakika',
  'specs.xyMaxSpeedIdle': 'X/Y Maksimum Hızı Boşta',
  'specs.xyMaxSpeedIdleValue': '30 metre/dakika',
  'specs.xyMaxAcceleration': 'X/Y Maksimum İvmelenme',
  'specs.laserSource': 'Lazer Kaynağı',
  'specs.laserHead': 'Lazer Kesim Kafası',
  'specs.body': 'Gövde',
  'specs.bodyValue': 'Ajan Lazer',
  'specs.xyRail': 'X/Y Hassas Eksen Rayı',
  'specs.xyRack': 'X/Y Hassas Eksen Kramiyer',
  'specs.xyRackValue': 'Tayvan',
  'specs.servoMotors': 'X/Y/Z Servo Motorları ve Sürücüleri',
  'specs.reducer': 'Redüktör',
  'specs.electricalComponents': 'Elektriksel Komponentler',
  'specs.lubricationSystem': 'Otomatik Yağlama Sistemi',
  'specs.lubricationSystemValue': 'Çin',
  'specs.chiller': 'Soğutucu (Air Chiller)',
  'specs.pneumaticComponents': 'Pnömatik Komponentler',
  'specs.cncControl': 'CNC Kontrol Sistemi',
  
  // Advantages
  'advantages.title': 'Öne Çıkan Avantajlar',
  'advantages.fullSafety': 'Tam Güvenlik',
  'advantages.fullSafetyDesc': 'Kapalı kabin tasarımı ile maksimum operatör güvenliği',
  'advantages.compactDesign': 'Kompakt Tasarım',
  'advantages.compactDesignDesc': 'Küçük alan gereksinimi ile verimli yerleşim',
  'advantages.excellentCutting': 'Mükemmel Kesim Kalitesi',
  'advantages.excellentCuttingDesc': 'Pürüzsüz kenar yüzeyleri ve hassas kesim performansı',
  'advantages.energyEfficiency': 'Enerji Verimliliği',
  'advantages.energyEfficiencyDesc': 'Düşük enerji tüketimi ile ekonomik çalışma',
  'advantages.wideWorkArea': 'Geniş Çalışma Alanı',
  'advantages.wideWorkAreaDesc': 'Büyük ebatlı levhaların işlenmesi için ideal geniş çalışma alanı',
  'advantages.mobileCabinSystem': 'Hareketli Kabin Sistemi',
  'advantages.mobileCabinSystemDesc': 'Gezer kabin teknolojisi ile esnek ve verimli üretim',
  'advantages.highCapacity': 'Yüksek Üretim Kapasitesi',
  'advantages.highCapacityDesc': 'Seri üretim için optimize edilmiş yüksek kapasite',
  'advantages.easyMaintenance': 'Kolay Bakım',
  'advantages.easyMaintenanceDesc': 'Modüler yapı sayesinde kolay erişim ve hızlı bakım',
  
  // Features Section
  'features.title': 'Ajan Fiber Lazer Kesim Makinesinin Özellikleri',
  'features.subtitle': 'Yüksek teknoloji ve mühendislik mükemmelliği ile üretilen makinelerimizin öne çıkan özellikleri',
  'features.bodyStrength': 'Üstün Gövde Dayanıklılığı',
  'features.bodyStrengthDesc': 'Tavlamadan sonra kaba işleme ve ardından titreşim geriliminin hafifletilmesi sayesinde kaynağın iç gerilimi tamamen ortadan kaldırabilir. 12 metrelik portal frezeleme işlemiyle makine iyi bir sağlamlığa ve yüksek hassasiyete sahiptir ve deformasyon olmadan uzun süre kullanılabilir.',
  'features.beamStructure': 'Hafif ve Güçlü Kiriş Yapısı',
  'features.beamStructureDesc': 'Kiriş, çekme alüminyum kaynaklı entegre giriş benimser; iyi bir sağlamlığa, hafifliğe, hızlı dinamik tepkiye ve kararlı çalışmaya sahiptir ve deformasyon olmadan uzun süre kullanılabilir.',
  'features.servoSystems': 'Yüksek Performanslı Servo Sistemler',
  'features.servoSystemsDesc': 'X/Y/Z eksenlerinin tümü yüksek hassasiyet, yüksek hız, büyük tork ile istikrarlı ve dayanıklı performans özelliklerine sahip DELTA servo motorlarını kullanır. Yüksek performans kesme başlığının kalın plakayı delmesi yalnızca birkaç saniyeye ihtiyaç duyar.',
  'features.ventilationSystem': 'Gelişmiş Havalandırma Sistemi',
  'features.ventilationSystemDesc': 'Havalandırma sistemi duman tahliye etkisinin sürekliliğini sağlayan kapalı alan yapısını kullanır. Böylelikle makine yatağının hızlanması daha istikrarlı ve hızlı hale gelir.',
  'features.modularDesign': 'Modüler ve Bakım Dostu Tasarım',
  'features.modularDesignDesc': 'Sektörün ilk basit entegre tasarımı, gelecekte gerekli olabilecek bakım ve revizyonlara uygun ayrılabilir yapıya sahiptir.',
  
  // Trust Section
  'trust.badge': '1973\'ten bugüne...',
  'trust.title': '50 Yıllık Deneyim ve 15 Yıllık Ar-Ge Çalışmalarıyla Türkiye\'nin Öncüsüyüz',
  'trust.description': '1973 yılından bu yana sektörde faaliyet gösteren firmamız, 15 yıl süren titiz Ar-Ge çalışmalarıyla CNC Fiber Lazer Kesim teknolojisinde lider konuma ulaşmıştır. 70+ ülkede 6000+ makine ile global ölçekte başarısını sürdürmektedir.',
  'trust.experience': 'Yıllık Deneyim',
  'trust.machines': 'Kurulu Makine',
  'trust.countries': 'Ülke',
  'trust.laserRD': 'Yıl Lazer Ar-Ge',
  'trust.leadership': 'Yarım Asırlık Liderlik',
  'trust.leadershipDesc': '1973 yılından bu yana sektörde olan firmamız, 15 yıl süren titiz Ar-Ge çalışmalarının zirvesine ulaşarak CNC Fiber Lazer Kesim Makinelerini geliştirdik.',
  'trust.deepRoots': 'Derin Kökler ve Güven',
  'trust.deepRootsDesc': '50 yılı aşkın sektörel deneyimimiz ve kesim teknolojisindeki derin köklerimizle, her projede kalite standartlarının üzerinde çözümler sunuyoruz.',
  'trust.rdPeak': '15 Yıllık Ar-Ge Zirvesi',
  'trust.rdPeakDesc': 'On beş yıl boyunca süren titiz Ar-Ge çalışmalarımızın zirvesine ulaşarak, kesim teknolojisinde devrim yaratacak CNC Fiber Lazer Kesim Makinelerini geliştirdik.',
  
  // Certifications
  'cert.title': 'Kalite ve Güvenlik Standartları',
  'cert.description': 'AJAN LAZER makineleri, uluslararası kalite ve güvenlik standartlarına tam uyum içinde üretilmektedir. Müşterilerimize en yüksek kalitede ve güvenli ürünler sunmak önceliğimizdir.',
  'cert.ce': 'CE Sertifikası',
  'cert.ceDesc': 'Avrupa Uygunluk',
  'cert.iso12100': 'TS EN ISO 12100',
  'cert.iso12100Desc': 'Makine Güvenliği',
  'cert.iso60204': 'TS EN 60204-1',
  'cert.iso60204Desc': 'Elektrik Güvenliği',
  'cert.iso60974': 'TS EN IEC 60974-1',
  'cert.iso60974Desc': 'Güç Kaynağı Güvenliği',
  'cert.emcLvd': 'EMC ve LVD Testleri',
  
  // Application Areas
  'app.title': 'Uygulama Alanları',
  'app.subtitle': 'AJAN LAZER fiber lazer kesim makineleri ile çeşitli metal malzemelerde yüksek hassasiyetli kesim işlemleri gerçekleştirin',
  'app.aluminum': 'Alüminyum',
  'app.aluminumDesc': 'Hassas Kesim',
  'app.carbonSteel': 'Karbon Çeliği',
  'app.carbonSteelDesc': 'Güçlü Kesim',
  'app.brass': 'Pirinç',
  'app.brassDesc': 'Kaliteli İşleme',
  'app.stainlessSteel': 'Paslanmaz Çelik',
  'app.stainlessSteelDesc': 'Pürüzsüz Yüzey',
  'app.otherMetals': 'Diğer Metaller',
  'app.otherMetalsDesc': 'Çok Yönlü',
  'app.materialsTitle': 'Uygulanabilir Malzemeler',
  'app.materialsDesc1': 'AJAN LAZER fiber lazer kesim makineleri, geniş bir metal yelpazesinde üstün kesim performansı sunar. Paslanmaz çelik, karbon çeliği, galvanizli sac, elektrolizli levha, alüminyum, bakır, pirinç, bronz ve diğer metal malzemelerin kesilmesinde yüksek hassasiyet ve kalite sağlar.',
  'app.materialsDesc2': 'İnce metal levhaların işlenmesinde öne çıkan makinelerimiz; otomotiv, havacılık, elektronik, mobilya, dekorasyon, reklam ve metal işleme sektörlerinde yaygın olarak kullanılmaktadır.',
  'app.materialsDesc3': 'Gelişmiş fiber lazer teknolojisi sayesinde farklı kalınlık ve türde metaller hızlı, ekonomik ve hassas şekilde kesilerek karmaşık geometriler kolaylıkla işlenebilir.',
  
  // After Sales Service
  'service.title': 'Satış Sonrası Servis',
  'service.subtitle': 'Güçlü teknik destek ekibimiz ve Türkiye genelindeki servis ağımızla yanınızdayız',
  'service.warranty': '2 Yıl Garanti',
  'service.warrantyDesc': 'Kesim makinasının garanti süresi üretim ve imalat hatalarına karşı 2 yıldır. Garanti süresiine arızaya dayalı yedek parça değişimleri ücretsiz olarak sağlanacaktır.',
  'service.exclusions': 'Garanti Kapsamı Dışındakiler',
  'service.exclusionsDesc': 'Kesme kafasının içindeki toz kirliliği, optik kablolar, QBH çıkış kafaları, yoğuşma veya dahili buzlanma nedeniyle lazer, genel sarf malzemeleri (optik lensler, kesme nozulları vb. gibi) ve kazalar garanti kapsamında değildir.',
  'service.technicalSupport': 'Güçlü Teknik Destek',
  'service.technicalSupportDesc': '7/24 teknik destek hattımız ile her zaman yanınızdayız',
  'service.fastService': 'Hızlı Servis',
  'service.fastServiceDesc': 'Türkiye genelindeki servis ağımızla hızlı müdahale',
  'service.spareParts': 'Yedek Parça Stoklu',
  'service.sparePartsDesc': 'Geniş yedek parça stoğumuz ile kesintisiz üretim',
  'service.expertTeam': 'Uzman Ekip',
  'service.expertTeamDesc': 'Deneyimli teknik ekibimiz ile profesyonel destek',
  
  // Why Choose Us
  'why.title': 'Neden AJAN LAZER?',
  'why.subtitle': 'Sektörde fark yaratan değerlerimiz ve müşteri odaklı yaklaşımımız',
  'why.reliableTech': 'Güvenilir Teknoloji',
  'why.reliableTechDesc': 'Dünya standartlarında komponentler ve kanıtlanmış performans',
  'why.affordableCost': 'Uygun Maliyet',
  'why.affordableCostDesc': 'Yüksek kalite ve rekabetçi fiyatlandırma ile en iyi yatırım getirisi',
  'why.continuousInnovation': 'Sürekli İnovasyon',
  'why.continuousInnovationDesc': 'Ar-Ge çalışmaları ile sürekli gelişen ve yenilenen ürün gamı',
  'why.customerFocused': 'Müşteri Odaklı Yaklaşım',
  'why.customerFocusedDesc': 'İhtiyaçlarınıza özel çözümler ve satış sonrası tam destek',
  
  // CTA Section
  'cta.title': 'Üretim Sürecinizi Dönüştürmeye Hazır mısınız?',
  'cta.subtitle': 'İhtiyacınıza en uygun fiber lazer çözümünü birlikte belirleyelim.',
  'cta.callNow': 'Hemen Arayın: 444 25 26',
  'cta.viewCatalogs': 'Katalogları İnceleyin',
  
  // Contact Form
  'form.title': 'Teklif Al',
  'form.subtitle': 'Teknik ekibimiz talebinizi analiz ederek en kısa sürede sizinle iletişime geçer.',
  'form.companyName': 'Firma İsmi',
  'form.companyNamePlaceholder': 'Firma adınızı girin',
  'form.fullName': 'Adınız Soyadınız',
  'form.fullNamePlaceholder': 'Adınız ve soyadınız',
  'form.email': 'E-posta Adresi',
  'form.emailPlaceholder': 'ornek@email.com',
  'form.phone': 'Telefon Numarası',
  'form.phonePlaceholder': '0555 555 55 55',
  'form.address': 'Adres Bilgisi',
  'form.addressPlaceholder': 'Adres bilginizi girin',
  'form.message': 'Mesajınız',
  'form.messagePlaceholder': 'Teklif talebiniz hakkında detaylı bilgi verin (maksimum 500 karakter)',
  'form.characters': 'karakter',
  'form.submit': 'Teklif Talebini Gönder',
  'form.submitting': 'Gönderiliyor...',
  'form.success': 'Formunuz başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
  'form.error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  'form.required': '*',
  
  // Footer
  'footer.description': 'Türkiye\'nin önde gelen fiber lazer kesim makinesi üreticisi. Yenilikçi teknoloji ve güvenilir çözümler.',
  'footer.quickLinks': 'Hızlı Bağlantılar',
  'footer.home': 'Ana Sayfa',
  'footer.catalog': 'Katalog',
  'footer.fairs': 'Fuarlar',
  'footer.cuttingThickness': 'Kesim Kalınlıkları',
  'footer.contact': 'İletişim',
  'footer.factory': 'Fabrika:',
  'footer.customerService': 'Müşteri Hizmetleri:',
  'footer.phone': 'Telefon:',
  'footer.fax': 'Faks:',
  'footer.email': 'Email:',
  'footer.address': 'Adres:',
  'footer.certifications': 'Sertifikalar',
  'footer.ceCertificate': 'CE Sertifikası',
  'footer.iso9001': 'ISO 9001',
  'footer.emcLvdTests': 'EMC ve LVD Testleri',
  'footer.tsEnIso12100': 'TS EN ISO 12100',
  'footer.rights': '© 2025 AJAN LAZER. Tüm hakları saklıdır.',
  'footer.websiteBuilder': 'Website Builder',
  
  // Catalog Page
  'catalog.title': 'Ürün Katalogları',
  'catalog.subtitle': 'AJAN FIBER lazer kesim makineleri kataloglarını inceleyerek ihtiyacınıza en uygun modeli keşfedin',
  'catalog.closedCabinTitle': 'Kapalı Kabin Fiber Lazer Kataloğu',
  'catalog.closedCabinDesc': 'Kompakt tasarım ve yüksek güvenlik standartlarına sahip kapalı kabin fiber lazer kesim makineleri. Küçük ve orta boy parça üretimi için ideal çözüm.',
  'catalog.mobileCabinTitle': 'Gezer Kabin Fiber Lazer Kataloğu',
  'catalog.mobileCabinDesc': 'Geniş sac işleme kapasitesine sahip gezer kabin fiber lazer kesim makineleri. Yüksek üretim hacmi gerektiren işletmeler için profesyonel çözüm.',
  'catalog.features': 'Öne Çıkan Özellikler',
  'catalog.feature1': 'Tamamen kapalı güvenli çalışma alanı',
  'catalog.feature2': 'Kompakt tasarım',
  'catalog.feature3': 'Kolay malzeme yükleme',
  'catalog.feature4': 'Enerji verimliliği',
  'catalog.feature5': 'Geniş çalışma alanı',
  'catalog.feature6': 'Mobil kabin sistemi',
  'catalog.feature7': 'Büyük sac işleme',
  'catalog.feature8': 'Yüksek üretim kapasitesi',
  'catalog.downloadPdf': 'PDF Kataloğu İndir',
  'catalog.ctaTitle': 'Detaylı Bilgi ve Fiyat Teklifi',
  'catalog.ctaSubtitle': 'Ürünlerimiz hakkında daha fazla bilgi ve özel fiyat teklifi için bizimle iletişime geçin',
  'catalog.ctaButton': '444 25 26',
  'catalog.closedCabinPdfUrl': 'https://files.ajanlazer.com/wp-content/uploads/2025/03/AJAN-FIBER-LAZER-KESIM-MAKINELERI-KATALOG-2024-TR-Comp.pdf',
  'catalog.mobileCabinPdfUrl': 'https://files.ajanlazer.com/wp-content/uploads/2025/11/gezer_kabin.pdf',
  
  // Fairs Page
  'fairs.title': 'Fuar ve Etkinlik Takvimi',
  'fairs.subtitle': 'AJAN LAZER\'i ulusal ve uluslararası fuarlarda ziyaret edin, ürünlerimizi yakından inceleyin',
  'fairs.upcoming': 'Yaklaşan Fuarlar',
  'fairs.upcomingDesc': 'Bizi ziyaret edebileceğiniz gelecek etkinlikler',
  'fairs.past': 'Geçmiş Fuarlar',
  'fairs.pastDesc': 'Katıldığımız önceki etkinlikler',
  'fairs.details': 'DETAYLAR',
  'fairs.noUpcoming': 'Yaklaşan fuar bulunmamaktadır.',
  'fairs.noPast': 'Geçmiş fuar kaydı bulunmamaktadır.',
  'fairs.ctaTitle': 'Fuarlarda Görüşmek Üzere',
  'fairs.ctaSubtitle': 'Standımızı ziyaret edin, ürünlerimizi yakından inceleyin ve uzman ekibimizle tanışın',
  'fairs.callForAppointment': 'Randevu İçin Arayın',
  
  // Cutting Thickness Page
  'thickness.title': 'Kesim Kalınlıkları',
  'thickness.subtitle': 'Lazer Gücüne Göre Maksimum Kesim Kapasiteleri',
  'thickness.chartTitle': 'Kesim Kapasiteleri Tablosu',
  'thickness.laserPower': 'Lazer Gücü',
  'thickness.iron': 'Demir',
  'thickness.stainlessSteel': 'Paslanmaz Çelik',
  'thickness.aluminum': 'Alüminyum',
  'thickness.brass': 'Pirinç',
  'thickness.materialTypes': 'Malzeme Türleri',
  'thickness.importantNotes': 'Önemli Notlar',
  'thickness.note1': '• Kesim kalınlıkları, optimal çalışma koşullarında elde edilen maksimum değerlerdir.',
  'thickness.note2': '• Gerçek kesim performansı, malzeme kalitesi ve çalışma koşullarına göre değişiklik gösterebilir.',
  'thickness.note3': '• Detaylı teknik bilgi ve özel uygulamalar için lütfen bizimle iletişime geçin.',
  'thickness.techAdvantages': 'Teknik Avantajlar',
  'thickness.highPower': 'Yüksek Güç Seçenekleri',
  'thickness.highPowerDesc': '3KW\'tan 20KW\'a kadar geniş güç aralığı ile her ihtiyaca uygun çözüm',
  'thickness.versatileMaterial': 'Çok Yönlü Malzeme Desteği',
  'thickness.versatileMaterialDesc': 'Demir, paslanmaz çelik, alüminyum ve pirinç gibi çeşitli malzemelerde kesim',
  'thickness.maxEfficiency': 'Maksimum Verimlilik',
  'thickness.maxEfficiencyDesc': 'Yüksek kesim hızı ve mükemmel kenar kalitesi ile üretim verimliliği',
  'thickness.ctaTitle': 'İhtiyacınıza Uygun Gücü Belirleyin',
  'thickness.ctaSubtitle': 'Hangi lazer gücünün işletmeniz için ideal olduğunu öğrenmek için uzmanlarımızla görüşün',
  'thickness.callForAppointment2': 'Randevu İçin Arayın: 444 25 26',
  
  // Layout Plan Page
  'layoutPlan.title': 'Yerleşim Planları',
  'layoutPlan.subtitle': 'Fiber lazer kesim makinelerimizin teknik yerleşim planlarını görüntüleyin ve indirin',
  'layout.title': 'Yerleşim Planı',
  'layout.subtitle': 'Fiber lazer kesim makinelerinizin fabrika veya atölye içinde optimal yerleşimi için detaylı teknik çizimler ve planlar',
  'layout.closedLaser': 'Kapalı Kabin',
  'layout.mobileCabin': 'Gezer Kabin',
  'layout.uploadPng': 'PNG Dosyası Yükle',
  'layout.loading': 'Yükleniyor...',
  
  // Closed Cabin Page
  'closedCabin.title': 'Kapalı Kabin Fiber Lazer',
  'closedCabin.subtitle': 'Kompakt tasarım ve yüksek güvenlik standartları ile kapalı kabin fiber lazer kesim makineleri',
  'closedCabin.ctaTitle': 'Kapalı Kabin Fiber Lazer Hakkında Detaylı Bilgi Alın',
  'closedCabin.ctaSubtitle': 'Teknik ekibimiz size en uygun çözümü sunmak için hazır',
  'closedCabin.callNow': 'Hemen Arayın: 444 23 26',
  'closedCabin.downloadCatalog': 'Katalog İndir',
  
  // Mobile Cabin Page
  'mobileCabin.title': 'Gezer Kabin Fiber Lazer',
  'mobileCabin.subtitle': 'Büyük ebatlı levha işleme kapasitesi ile profesyonel çözüm',
  'mobileCabin.overview': 'Yüksek Kapasite, Maksimum Verimlilik',
  'mobileCabin.overviewDesc1': 'AJAN LAZER Gezer Kabin Fiber Lazer Kesim Makineleri, büyük ebatlı levha işleme kapasitesi ile yüksek üretim hacmi gerektiren işletmeler için profesyonel çözüm sunar. Hareketli kabin sistemi sayesinde geniş çalışma alanında esnek ve verimli üretim yapabilirsiniz.',
  'mobileCabin.overviewDesc2': 'Dünya standartlarında komponentler ve ileri teknoloji ile donatılmış makinelerimiz, seri üretimde maksimum performans ve hassasiyet sağlar.',
  'mobileCabin.advantages': 'Avantajlar',
  'mobileCabin.advantagesSubtitle': 'Gezer Kabin Fiber Lazer ile kazanacağınız üstünlükler',
  'mobileCabin.ctaTitle': 'Detaylı Bilgi ve Fiyat Teklifi',
  'mobileCabin.ctaSubtitle': 'Gezer Kabin Fiber Lazer hakkında daha fazla bilgi almak için bizimle iletişime geçin',
  'mobileCabin.totalSpecs': 'Toplam Özellik',
  'mobileCabin.specsListed': 'Teknik Özellik Başarıyla Listelendi',
};
